export default __webpack_public_path__ + "static/media/nimbus_about_img.049fb80a.png";